import React from 'react';
import { HeaderBar } from './styles';
import logo from '../../assets/images/Hubblehox_logo.webp';

export default function Header() {
    return (
        <HeaderBar component="header">
            <img src={logo} alt="HUBBLEHOX" style={{ height: 50, objectFit: 'contain' }} />
        </HeaderBar>
    );
}
